<template >
    <div class="member-approach-time-dialog">
        <el-dialog :visible.sync="visible" :title="$t('Sell.add_card_time')" left>
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                :status-icon="true"
                label-position="right"
                label-width="130px"
                label-suffix=":"
            >
                <el-form-item prop="isTimeLimit" :label="$t('Sell.limi_enter_time')">
                    <el-radio-group v-model="form.isTimeLimit">
                        <el-radio :label="true">{{ $t('Common.yes') }}</el-radio>
                        <el-radio :label="false">{{ $t('Common.no') }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <template v-if="form.isTimeLimit===true">
                    <el-form-item :label="$t('Common.enter_time')">
                        <div
                            class="approach-time-box-darkgray"
                            v-for="(item, itemIndex) in form.enterTimes"
                            :key="itemIndex">
                            <p class="member-box-input">
                                <span v-for="(day,index) in item.days " :key="index" >
                                    <span
                                        v-for="value in week"
                                        v-if="value.value === day"
                                        :key="value.value">
                                        {{value.name}}{{item.days[index+1] ? '、' : ''}}
                                    </span>
                                </span>
                            </p>
                            <p class="member-box-input">{{item.startAt+'~'+item.endAt}}</p>
                            <i
                                class="el-icon-error absolute delete-img"
                                @click.prevent="form.enterTimes.splice(itemIndex, 1);"
                            />
                        </div>
                        <el-button
                            icon="el-icon-plus"
                            @click.native="showAdd=true"
                            type="primary"
                            plain
                        >{{ $t('tooltip.add') }}</el-button>
                    </el-form-item>
                </template>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="postData" type="primary">{{ $t('Common.save') }}</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="showAdd" :title="$t('Sell.Dialog.add_time')" left>
            <el-form
                ref="addTime"
                :model="enterTime"
                :status-icon="true"
                label-position="right"
                label-width="80px"
                label-suffix=":"
            >
                <el-checkbox-group v-model="enterTime.days">
                    <el-checkbox
                        v-for="item in week"
                        :label="item.value"
                        :key="item.value"
                        style="margin-top: 10px; overflow:hidden"
                        border
                    >{{item.name}}</el-checkbox>
                </el-checkbox-group>
                <el-form-item :label="$t('Common.enter_time')">
                    <div
                        class="approach-time-box-darkgray"
                        v-for="(item, index) in enterTime.times"
                        :key="index">
                    <el-time-picker
                        v-model="item.startAt"
                        :picker-options="{
                            selectableRange: `00:00:00 - ${item.endAt ? item.endAt : '23:59:59'}`
                        }"
                        :placeholder="$t('Choose.time')"
                        style="width:200px"
                        value-format="HH:mm:ss"
                    />
                    <el-time-picker
                        v-model="item.endAt"
                        :picker-options="{
                            selectableRange: `${item.startAt ? item.startAt : '00:00:00'} - 23:59:59`
                        }"
                        :placeholder="$t('Choose.time')"
                        style="width:200px"
                        value-format="HH:mm:ss"
                    />
                    <i
                        class="el-icon-error absolute delete-img"
                        @click.prevent="removeTime(item)"
                    />
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button
                    icon="el-icon-plus"
                    @click.prevent="enterTime.times.push(time)"
                    type="primary"
                    value-format="HH:mm:ss"
                    plain
                >{{ $t('tooltip.add') }}</el-button>
                <el-button @click="submitTime" type="primary">{{ $t('Common.save') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    Dialog,
    DatePicker,
    RadioGroup,
    Radio,
    CheckboxGroup,
    CheckboxButton,
    TimePicker,
    Row,
} from 'element-ui';

export default {
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRadioGroup: RadioGroup,
        ElRadio: Radio,
        ElCheckboxGroup: CheckboxGroup,
        ElCheckboxButton: CheckboxButton,
        ElTimePicker: TimePicker,
        ElRow: Row,
    },
    data() {
        return {
            week: [
                {
                    value: 1,
                    name: this.$t('Week.monday'),
                },
                {
                    value: 2,
                    name: this.$t('Week.Tuesday'),
                },
                {
                    value: 3,
                    name: this.$t('Week.wednesday'),
                },
                {
                    value: 4,
                    name: this.$t('Week.thursday'),
                },
                {
                    value: 5,
                    name: this.$t('Week.friday'),
                },
                {
                    value: 6,
                    name: this.$t('Week.saturday'),
                },
                {
                    value: 7,
                    name: this.$t('Week.sunday'),
                },
            ],
            enterTime: { days: [], times: [{ startAt: null, endAt: null }] },
            enterTimes: [],
            timeReq: { days: [], startAt: null, endAt: null },
            showAdd: false,
            time: { startAt: null, endAt: null },
            stores: [],
            visible: false,
            form: {
                cardId: '',
                isTimeLimit: null,
                enterTimes: [],
            },
            rules: {},
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
    },
    methods: {
        resetForm() {
            this.$refs.form.resetFields();
        },
        open(data) {
            if (data) {
                this.fetchData(data);
                this.visible = true;
            }
        },
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = res;
            });
        },
        fetchData(data) {
            API.get(`member-card/${data}/enter-time`).then(res => {
                this.form.isTimeLimit = res.isTimeLimit;
                this.form.cardId = res.cardId;
                this.form.enterTimes = res.times;
            });
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                this.visible = false;
            });
        },
        removeTime(item) {
            const index = this.enterTime.times.indexOf(item);
            if (index !== -1) {
                this.enterTime.times.splice(index, 1);
                this.time = {};
            }
        },
        removeFormTime(index) {
            this.form.enterTimes.splice(index, 1);
        },
        submitTime() {
            const days = this.enterTime.days;
            let judge = true;
            if (days.length < 1) return $ele.$message.error(this.$t('Choose.cycle'));
            const times = this.enterTime.times;
            times.forEach(t => {
                if (!t.startAt || !t.endAt) {
                    judge = false;
                    return $ele.$message.error(this.$t('Fill.start_end_time'));
                }
            });
            if (judge) {
                const timeList = [];
                this.enterTime.times.forEach(t => {
                    this.timeReq.days = this.enterTime.days;
                    this.timeReq.startAt = t.startAt;
                    this.timeReq.endAt = t.endAt;
                    timeList.push(this.timeReq);
                    this.form.enterTimes ? this.form.enterTimes.push(this.timeReq) : (this.form.enterTimes = timeList);
                    this.timeReq = {};
                });
                this.showAdd = false;
                this.resetEnterTime();
            }
        },
        resetEnterTime() {
            this.enterTime = { days: [], times: [{ startAt: null, endAt: null }] };
            this.timeReq = { days: [], startAt: null, endAt: null };
            this.time = { startAt: null, endAt: null };
        },
        pushEnterTime() {
            if (this.enterTime.times.length > 0) this.enterTime.times.push(this.time);
            else this.enterTime.times[0] = this.time;
        },
        postData() {
            if(this.form.isTimeLimit && ( typeof this.form.enterTimes == "undefined"
                || this.form.enterTimes == null
                || this.form.enterTimes.length < 1)){
                return $ele.$message.error(this.$t('Choose.enter_times'));
            }
            this.$delete(this.form, 'timesContentText');

            API.put(`member-card/${this.form.cardId}/enter-time`, this.form)
            .then(res => {
                $ele.$message.success(this.$t('Message.save'));
                this.$emit('input', 'update');
                this.visible = false;
            })
            .finally(() => {
                this.loading = false;
            })
            .catch(err => {
                $ele.$message.error(err);
            });
        },
    },
};
</script>

<style lang="scss">
.approach-time-box-darkgray {
  padding: 10px;
  position: relative;
  background: #eee !important;
  min-height: 30px;
  margin-top: 10px;
}
.approach-time-box-darkgray {
  .member-box-input {
    word-wrap: break-word;
    font-size: 12px;
  }
  .icon-i {
    font-size: 10px;
    font-style: normal;
    display: inline-block;
    -ms-user-select: none;
    -khtml-user-select: none;
    user-select: none;
    min-width: 20px;
    text-align: center;
    position: absolute;
    right: 14px;
    top: 15px;
    font-size: 20px;
    color: #575c62;
    cursor: pointer;
  }
}
.member-approach-time-dialog {
    .el-dialog--center .el-dialog__body {
        padding: 25px 25px 0;
    }
    .delete-img {
        top: 0px;
        right: 0px;
        color: gray;
        font-size: 14px;
    }
    .el-dialog__body {
        height: 30vh;
        overflow: auto;
    }
}
</style>Î
